import { render, staticRenderFns } from "./group-select.vue?vue&type=template&id=9727e734"
import script from "./group-select.vue?vue&type=script&lang=js"
export * from "./group-select.vue?vue&type=script&lang=js"
import style0 from "./group-select.vue?vue&type=style&index=0&id=9727e734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports